import type { UserConsentId } from '@paid-ui/enums/consent';

import { useQuery } from '@tanstack/react-query';

import { consentIdTypeMap } from '@paid-ui/constants';
import { useToast } from '@paid-ui/ui/toast';
import { request } from '@paid-ui/utils/axios';

interface ConsentSource {
  id: UserConsentId;
  link: string;
}

type GetConsentResponse = {
  data: {
    version: string;
    source: ConsentSource[];
  };
} | null;

export const useGetConsent = (consentId: UserConsentId) => {
  const toast = useToast();
  const consentItem = consentIdTypeMap[consentId];

  return useQuery({
    enabled: Boolean(consentItem),
    queryKey: ['GetConsent', consentItem],
    queryFn: async ({ signal }) => {
      const { data } = await request.get<GetConsentResponse>(`/users/consent/${consentItem}`, {
        signal,
      });
      return data?.data;
    },
    select: (data) => data?.source.find((item) => item.id === consentId) ?? null,
    onError(error) {
      toast.error(error instanceof Error ? error.message : 'Failed to get user consent.');
    },
  });
};
